"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("./app"));
exports.default = (function () {
    var GroupedContentStandardElements = Array.from(document.querySelectorAll('.GroupedContent--standard'));
    var GroupedContentRobustElements = Array.from(document.querySelectorAll('.GroupedContent--robust'));
    app_1.default(GroupedContentStandardElements, false);
    app_1.default(GroupedContentRobustElements, true);
});
